"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Tickers_1 = require("./Tickers");
var input_1 = require("../input");
var TimePicker_st_css_1 = require("./TimePicker.st.css");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var filter_data_props_1 = require("../../utils/filter-data-props");
// TODO: make all _prefix private when the parser won't choke on it
/**
 * Time Picker - following the Chrome on Mac behavior (mostly)
 */
var TimePicker = /** @class */ (function (_super) {
    tslib_1.__extends(TimePicker, _super);
    function TimePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: _this.props.value && utils_1.isValidTime(_this.props.value)
                ? _this.props.value.substr(0, 5)
                : constants_1.NULL_TIME,
            focus: false,
        };
        _this._shouldHighlightOnFocus = true;
        _this._hasStartedTyping = false;
        _this._mouseDown = false;
        _this._lastFocusedField = constants_1.FIELD.BEFORE;
        _this._inputRef = null;
        _this._highlightField = _this._highlightField.bind(_this);
        _this._onMouseDown = _this._onMouseDown.bind(_this);
        _this._onMouseUp = _this._onMouseUp.bind(_this);
        _this._onMouseMove = _this._onMouseMove.bind(_this);
        _this._onClick = _this._onClick.bind(_this);
        _this._onBlur = _this._onBlur.bind(_this);
        _this._onFocus = _this._onFocus.bind(_this);
        _this._onKeyDown = _this._onKeyDown.bind(_this);
        _this._tick = _this._tick.bind(_this);
        return _this;
    }
    TimePicker.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var value = nextProps.value;
        if (this.props.value !== value) {
            if (!value || !utils_1.isValidTime(value)) {
                value = constants_1.NULL_TIME;
            }
            this.setState({ value: value.substr(0, 5) });
        }
    };
    TimePicker.prototype._highlightField = function (input, field) {
        var startPos = (field - 1) * 3;
        if (startPos < 0) {
            return;
        }
        input.setSelectionRange(startPos, startPos + 2);
    };
    TimePicker.prototype._onMouseDown = function () {
        this._shouldHighlightOnFocus = false;
        this._hasStartedTyping = false;
        this._mouseDown = true;
    };
    TimePicker.prototype._onMouseUp = function () {
        this._mouseDown = false;
    };
    TimePicker.prototype._onMouseMove = function (e) {
        if (this._mouseDown) {
            e.preventDefault();
        }
    };
    TimePicker.prototype._onClick = function (e) {
        var _this = this;
        // Highlighting on click instead of mousedown because the selectionStart isn't set yet
        e.preventDefault();
        var elem = e.target;
        var field = utils_1.getFieldFromPos(elem.selectionStart);
        // Using setTimeout because otherwise mouse clicking on a selection will de-select :/
        setTimeout(function () { return _this._highlightField(elem, field); }, 0);
    };
    TimePicker.prototype._onBlur = function (e) {
        var _this = this;
        this._shouldHighlightOnFocus = e.target !== document.activeElement;
        this._hasStartedTyping = false;
        this._lastFocusedField = utils_1.getFieldFromPos(e.target.selectionStart);
        // Validate on blur and call onChange if needed
        var value = this.state.value;
        var _a = this.props, onChange = _a.onChange, useAmPm = _a.useAmPm;
        if (value === constants_1.NULL_TIME) {
            if (this.props.value) {
                onChange(null);
            }
        }
        else if (utils_1.isValidTime(value, useAmPm !== constants_1.AmPmOptions.None)) {
            if (this.props.value !== value) {
                onChange(value);
            }
        }
        else {
            var _b = utils_1.parseTime(value), hour = _b.hour, minute = _b.minute;
            var nHour = parseInt(hour, 10) || 0;
            var nMinute = parseInt(minute, 10) || 0;
            if (nMinute > 59) {
                nMinute = 59;
            }
            value = utils_1.leftpad(nHour) + ":" + utils_1.leftpad(nMinute);
            this.setState({ value: value }, function () {
                if (value !== _this.props.value) {
                    onChange(value);
                }
            });
        }
        this.setState({ focus: false });
        this.props.onBlur && this.props.onBlur(e);
    };
    TimePicker.prototype._onFocus = function (e) {
        if (this._shouldHighlightOnFocus) {
            var elem = e.target;
            this._highlightField(elem, constants_1.FIELD.HOUR);
            this._hasStartedTyping = false;
        }
        this.setState({ focus: true });
        this.props.onFocus && this.props.onFocus(e);
    };
    TimePicker.prototype._onKeyDown = function (e) {
        /*
          Respond to:
          - tab
          - numbers
          - case-insensitive A, P (for am/pm)
          - arrow keys
          - delete and backspace
        */
        var _this = this;
        if (e.altKey || e.ctrlKey || e.metaKey || this.props.readOnly) {
            return;
        }
        var elem = e.target;
        var startPos = elem.selectionStart;
        var _a = this.props, useAmPm = _a.useAmPm, onChange = _a.onChange;
        var value = this.state.value;
        var currentField = utils_1.getFieldFromPos(startPos);
        var isAmPm = useAmPm !== constants_1.AmPmOptions.None;
        // Checking for TAB first because it's the only key that might have default behavior
        // Shift focus between fields if tab is pressed, or use regular behavior if the field is on the edge
        // i.e., tabbing while on AM/PM or shift+tab on hour
        if (e.key === 'Tab') {
            currentField += e.shiftKey ? -1 : 1;
            if (currentField === constants_1.FIELD.HOUR ||
                currentField === constants_1.FIELD.MINUTE ||
                (currentField === constants_1.FIELD.AMPM && isAmPm)) {
                e.preventDefault();
                this._highlightField(elem, currentField);
            }
            return;
        }
        // Block other input default behavior
        e.preventDefault();
        // Handle numeric input
        if (/^[0-9]$/.test(e.key)) {
            var num = parseInt(e.key, 10);
            var _b = utils_1.parseTime(value), hour = _b.hour, minute = _b.minute;
            if (currentField === constants_1.FIELD.HOUR) {
                if (this._hasStartedTyping) {
                    var nHour = parseInt("" + hour[1] + num, 10);
                    if (nHour > 12 && isAmPm) {
                        nHour = 12;
                    }
                    if (nHour > 23) {
                        nHour = 23;
                    }
                    hour = "" + nHour;
                    currentField = constants_1.FIELD.MINUTE;
                    this._hasStartedTyping = false;
                }
                else {
                    if ((num > 1 && isAmPm) || num > 2) {
                        currentField = constants_1.FIELD.MINUTE;
                    }
                    else {
                        this._hasStartedTyping = true;
                    }
                    hour = e.key;
                }
            }
            else if (currentField === constants_1.FIELD.MINUTE) {
                if (this._hasStartedTyping) {
                    minute = "" + parseInt("" + minute[1] + num, 10);
                }
                else {
                    this._hasStartedTyping = true;
                    minute = e.key;
                }
            }
            value = utils_1.leftpad(hour) + ":" + utils_1.leftpad(minute);
            this.setState({ value: value }, function () {
                _this._highlightField(elem, currentField);
                if (utils_1.isValidTime(value)) {
                    onChange(value);
                }
            });
            return;
        }
        this._hasStartedTyping = false;
        // All the rest: arrow keys, tab, delete, backspace, A/P
        switch (e.key) {
            // Change focus on arrow left or right
            case 'ArrowLeft': {
                currentField -= 1;
                if (currentField === constants_1.FIELD.BEFORE) {
                    currentField = constants_1.FIELD.HOUR;
                }
                this._highlightField(elem, currentField);
                break;
            }
            case 'ArrowRight': {
                currentField += 1;
                if (currentField === constants_1.FIELD.AMPM && !isAmPm) {
                    currentField = constants_1.FIELD.MINUTE;
                }
                if (currentField === constants_1.FIELD.AFTER) {
                    currentField = constants_1.FIELD.AMPM;
                }
                this._highlightField(elem, currentField);
                break;
            }
            // Increment or decrement for up/down arrows
            case 'ArrowUp':
            case 'ArrowDown': {
                var step = this.props.step;
                value =
                    e.key === 'ArrowUp'
                        ? utils_1.increment({ value: value, field: currentField, step: step })
                        : utils_1.decrement({ value: value, field: currentField, step: step });
                this.setState({ value: value }, function () {
                    _this._highlightField(elem, currentField);
                    if (utils_1.isValidTime(value)) {
                        onChange(value);
                    }
                });
                break;
            }
            // AM / PM only if on relevant field
            case 'a':
            case 'A':
            case 'p':
            case 'P': {
                if (currentField !== constants_1.FIELD.AMPM) {
                    break;
                }
                var hour = utils_1.parseTime(value).hour;
                var nHour = parseInt(hour, 10);
                if ((nHour < 12 && (e.key === 'p' || e.key === 'P')) ||
                    (nHour > 11 && (e.key === 'a' || e.key === 'A'))) {
                    value = utils_1.increment({ value: value, field: constants_1.FIELD.AMPM });
                    this.setState({ value: value }, function () {
                        _this._highlightField(elem, constants_1.FIELD.AMPM);
                        onChange(value);
                    });
                }
                break;
            }
            // Change field to BLANK on delete or backspace. Ignore if field is AM/PM
            case 'Delete':
            case 'Backspace': {
                var _c = utils_1.parseTime(value), hour = _c.hour, minute = _c.minute;
                var callback = function () {
                    if (_this.state.value === constants_1.NULL_TIME) {
                        onChange(null);
                    }
                    _this._highlightField(elem, currentField);
                };
                if (currentField === constants_1.FIELD.HOUR) {
                    this.setState({ value: constants_1.BLANK + ":" + minute }, callback);
                }
                if (currentField === constants_1.FIELD.MINUTE) {
                    this.setState({ value: hour + ":" + constants_1.BLANK }, callback);
                }
                break;
            }
            default:
        }
    };
    TimePicker.prototype._tick = function (action) {
        var _this = this;
        if (this.props.readOnly) {
            return;
        }
        var startPos = this._inputRef.getSelectionStart();
        var currentField = utils_1.getFieldFromPos(startPos);
        var value = this.state.value;
        var _a = this.props, step = _a.step, onChange = _a.onChange;
        var field = this.state.focus
            ? currentField
            : this._lastFocusedField || constants_1.FIELD.MINUTE;
        value = action({ value: value, field: field, step: step });
        this.setState({ value: value }, function () {
            _this._highlightField(_this._inputRef, currentField);
            if (utils_1.isValidTime(value)) {
                onChange(value);
            }
        });
    };
    TimePicker.prototype.focus = function () {
        this._inputRef.focus();
    };
    TimePicker.prototype.blur = function () {
        this._inputRef.blur();
    };
    TimePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, useNativeInteraction = _a.useNativeInteraction, useAmPm = _a.useAmPm, tickerUpIcon = _a.tickerUpIcon, tickerDownIcon = _a.tickerDownIcon, inlineStyle = _a.style, disabled = _a.disabled, readOnly = _a.readOnly, className = _a.className, rest = tslib_1.__rest(_a, ["useNativeInteraction", "useAmPm", "tickerUpIcon", "tickerDownIcon", "style", "disabled", "readOnly", "className"]);
        var restOnChange = rest.onChange, restStep = rest.step, restValue = rest.value, allOther = tslib_1.__rest(rest, ["onChange", "step", "value"]);
        var passThroughProps = tslib_1.__assign(tslib_1.__assign({}, allOther), { disabled: disabled,
            readOnly: readOnly });
        if (useNativeInteraction) {
            var _b = this.props, propsValue = _b.value, onChange_1 = _b.onChange;
            var sanitizedValue = propsValue && utils_1.isValidTime(propsValue) ? propsValue.substr(0, 5) : '';
            return (React.createElement(input_1.Input, tslib_1.__assign({}, passThroughProps, { className: TimePicker_st_css_1.st(TimePicker_st_css_1.classes.root, className), type: "time", value: sanitizedValue, onChange: function (e) { return onChange_1(e.target.value); }, style: inlineStyle })));
        }
        var value = this.state.value;
        var focus = this.state.focus;
        if (useAmPm !== constants_1.AmPmOptions.None) {
            value = utils_1.convertToAmPm({ value: value, strings: constants_1.AmPmStrings[useAmPm] });
        }
        var tickers = tickerUpIcon && tickerDownIcon && (React.createElement(Tickers_1.Tickers, { className: TimePicker_st_css_1.classes.tickers, disabled: disabled, onIncrement: function () { return _this._tick(utils_1.increment); }, onDecrement: function () { return _this._tick(utils_1.decrement); }, tickerUpIcon: tickerUpIcon, tickerDownIcon: tickerDownIcon }));
        return (React.createElement(input_1.Input, tslib_1.__assign({}, passThroughProps, { className: TimePicker_st_css_1.st(TimePicker_st_css_1.classes.root, { focus: focus }, className), ref: function (ref) { return (_this._inputRef = ref); }, type: "text", value: value, suffix: tickers, onKeyDown: this._onKeyDown, onFocus: this._onFocus, onBlur: this._onBlur, onMouseDown: this._onMouseDown, onMouseUp: this._onMouseUp, onMouseMove: this._onMouseMove, onClick: this._onClick, onDragStart: function (e) { return e.stopPropagation(); }, style: inlineStyle }, filter_data_props_1.filterDataProps(this.props))));
    };
    TimePicker.displayName = 'TimePicker';
    TimePicker.defaultProps = {
        onChange: function () { return null; },
        useNativeInteraction: false,
        useAmPm: constants_1.AmPmOptions.None,
        step: 1,
        value: null,
        disabled: false,
    };
    return TimePicker;
}(React.PureComponent));
exports.TimePicker = TimePicker;
//# sourceMappingURL=TimePicker.js.map